import React from 'react';

import OrgSettingLayout from '@views/Organization/OrgSettingManagementLayout';
import OrgAlertSettings from '@views/Organization/Setting/AlertSettings';

export default function ManageOrgAlertRecipientSettingsPage(
  props: PagePropsWithBreadcrumbs
) {
  return (
    <OrgSettingLayout pageProps={props}>
      {({ account_id }) => <OrgAlertSettings account_id={account_id} />}
    </OrgSettingLayout>
  );
}
